import { render, staticRenderFns } from "./PlatformViewAllowedMails.vue?vue&type=template&id=42794f76&scoped=true&"
import script from "./PlatformViewAllowedMails.vue?vue&type=script&lang=js&"
export * from "./PlatformViewAllowedMails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42794f76",
  null
  
)

export default component.exports